export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref14801.7a61bdc9.jpg";